import { authClient } from "lib/auth-client";
import {
  assertAuthAttemptCurrent,
  authAttemptFetchOptions,
  beginAuthAttempt,
  type AuthAttempt,
} from "lib/auth-attempt";
import { BETTER_AUTH_REFERRAL_HEADER } from "utils/turnstileHeaders";

export type BetterAuthSocialProvider = "google" | "linkedin";

/**
 * Starts Google or LinkedIn sign-in. The referral code and sign-up attribution ride as headers
 * on this request; the backend keeps them in the signed OAuth state, so the callback needs
 * nothing from the app.
 */
export async function signInWithBetterAuthSocial(
  provider: BetterAuthSocialProvider,
  referralCode?: string | null,
  signupAttributionHeaders: Record<string, string> = {},
  attempt: AuthAttempt = beginAuthAttempt()
): Promise<void> {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const callbackURL = `${origin}/auth/oauth/callback`;
  const newUserCallbackURL = `${callbackURL}?new_user=1`;
  const referral = referralCode?.trim().toLowerCase();
  const headers: Record<string, string> = {
    ...signupAttributionHeaders,
    ...(referral ? { [BETTER_AUTH_REFERRAL_HEADER]: referral } : {}),
  };

  await authClient.signIn.social({
    provider,
    callbackURL,
    newUserCallbackURL,
    errorCallbackURL: callbackURL,
    fetchOptions: {
      ...authAttemptFetchOptions(attempt),
      ...(Object.keys(headers).length > 0 ? { headers } : {}),
    },
  });
  assertAuthAttemptCurrent(attempt);
}
